<template lang="">
    <div class="section-cv">
          <div class="heading2-section cv">
            Education
        </div>
           <!-- work -->
        <div class="work" v-for="education in educations" :key="education.educationId">
            <ItemGeneralInfo :place="education.school" :title="education.certificate" :start="education.startDate" :end="education.endDate"/>
            <div class="section-context" v-html="formattedDescription(education.description)"></div>
        </div>
        <!--  -->
       
    </div>
</template>
<script>
    import ItemGeneralInfo from './ItemGeneralInfo.vue';
    import DOMPurify from 'dompurify'
export default {
    components:{
        ItemGeneralInfo
    },
    computed:{
          educations(){
            var eds = this.$store.getters["cvbuilder/getCVInformation"]?.educations || [];
            return eds;
        }
    },
    methods:{
         formattedDescription(description) {
                if (!description) return '';

                // 1. Sanitize raw input (Strips XSS + <img> tags)
                let updated = DOMPurify.sanitize(description, { FORBID_TAGS: ['img'] });

                // 2. Convert <ol> tags into <ul> tags (and strip list type attributes)
                updated = updated.replace(/<ol(\s[^>]*)?>/gi, '<ul>');
                updated = updated.replace(/<\/ol>/gi, '</ul>');

                // 3. Strip existing inline background-color from user input
                updated = updated.replace(/background-color:\s*[^;"]+;?/gi, '');

                // 4. Strip existing inline text color from user input
                updated = updated.replace(/color:\s*[^;"]+;?/gi, '');

                // 5. Inject your custom theme styles into <p> tags safely
                updated = updated.replace(
                    /<p(\s[^>]*)?>/g,
                    '<p$1 style="background-color:transparent;color:black;padding:0rem;border-radius:0px;margin-bottom:1rem;">'
                );

                // 6. Remove empty paragraphs
                updated = updated.replace(/<p[^>]*><br><\/p>/g, '');

                return updated;
            },
    }
}
</script>
<style lang="">
    
</style>